import React from "react"

import { Wrapper, HeaderWrapper } from '../pageComponents/about.styles'
import { Footer } from "customMolecule"
import { Logo } from "customAtom"
import { Button } from 'atom'
import SEO from "../components/seo/SEO"
import Globals from "../components/globals/Globals"

const About = () => {

  return (
    <>
      <SEO />
      <Globals>
        <Wrapper>
          <header>
            <HeaderWrapper>
              <Logo />
              <Button text={"Let's go"} href={'/home'} />
            </HeaderWrapper>
          </header>
          <main>
            <h1>About</h1>
            <p>This site provides averaged temperatures and sunshine hours for popular destinations around the world. The mean is calculated across the selected figure and months, and separated into temperature ranges.
            <br />
              <br />
Good luck finding your next destination!</p>
          </main>
          <Footer extraPadding={false} />
        </Wrapper>
      </Globals >
    </>
  )
}


export const query = graphql`
  {
    
    imgLanding1: file(relativePath: { eq: "landing1.jpeg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    imgLanding2: file(relativePath: { eq: "landing2.jpeg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    imgLanding3: file(relativePath: { eq: "landing3.jpeg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

  }

`


export default About
